/* Built In Imports */
/* External Imports */
import { Box, Text } from '@chakra-ui/react';
import Slider from 'react-slick';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/* Styles */
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { pageCss } from './sections/ProgramDetails';

/**
 * Render Testimonial Common Component
 *
 * @param testimonials.testimonials
 * @param {object} testimonials
 * @param testimonials.lang
 * @returns {ReactElement} Testimonial Slider Component
 */
const TestimonialSlider = ({ testimonials, lang }) => {
  const settingsSmall = {
    dots: false,
    infinite: true,
    autoplay: false,
    lazyLoad: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    nextArrow: <></>,
    prevArrow: <></>,
    centerPadding: 0,
    responsive: [
      {
        breakpoint: 1170,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 834,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    testimonials?.length > 0 && (
      <Box
        m={{ base: '60px auto', md: '15px auto' }}
        display={{ lg: 'flex', md: 'block', sm: 'block' }}
        justifyContent="center"
        id="testimonial-slider"
        maxW="340px"
        //  maxH={428}
      >
        {' '}
        <Slider {...settingsSmall}>
          {testimonials?.map((testimonial, index) => (
            <Box
              bgColor="#f5f0e5"
              display={{ lg: 'flex', md: 'flex', base: 'block' }}
              textAlign="center"
              pt={{ lg: '0', md: '0', base: '20px' }}
              pb={{ lg: '0', md: '0', base: '20px' }}
              p="20px"
              maxW="296px"
              margin="0 20px 0 0"
              minHeight={pageCss[lang].testimonialHeight}
            >
              <LazyLoadImageComponent
                src={testimonial?.photo?.url}
                mr="1rem"
                height="170px"
                width="170px"
                borderRadius="50%"
              />
              <Box
                ml="auto"
                width={{ lg: '320px', md: '100%', sm: '100%' }}
                textAlign="left"
                lineHeight="29px"
                fontStyle="italic"
                pt={{ base: '10px' }}
              >
                {testimonial?.testimonialText}
                <br />
                <Text
                  fontWeight="bold"
                  pt={{ lg: '16px', md: '16px', base: '32px' }}
                  fontStyle="normal"
                >
                  {testimonial?.userName}
                </Text>
              </Box>
            </Box>
          ))}
        </Slider>
        <style global jsx>
          {`
            @media (max-width: 478px) {
              #testimonial-slider .slick-list .slick-active {
                width: 305px !important;
              }
            }
          `}
        </style>
      </Box>
    )
  );
};

export default TestimonialSlider;
